<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>เลข Serial Number</v-list-item-title>
            <v-list-item-subtitle>
              {{ hardwareInit.hardware_serial_number }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <v-text-field
          class="fix-google-chrome"
          :value="hardware.hardware_serial_number"
          label="เลข Serial Number"
          disabled
        ></v-text-field>
        <v-text-field
          class="fix-google-chrome"
          tabindex="1"
          v-model="hardware.hardware_code"
          :rules="[(v) => !!v || 'โปรดระบุรหัส Device']"
          required
          clearable
          @change="checkEmpty($event, 'hardware_code')"
        >
          <template #label>
            รหัส Device
            <span class="red--text"><strong>*</strong></span>
          </template>
        </v-text-field>
        <v-text-field
          class="fix-google-chrome"
          tabindex="2"
          v-model="hardware.title_th"
          :rules="[(v) => !!v || 'โปรดระบุชื่อ Device']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
        >
          <template #label>
            ชื่อ Device
            <span class="red--text"><strong>*</strong></span>
          </template>
        </v-text-field>
        <v-text-field
          class="fix-google-chrome"
          tabindex="3"
          v-model="hardware.title_en"
          label="ชื่อ Device (อังกฤษ)"
          clearable
          @change="checkEmpty($event, 'title_en')"
        ></v-text-field>
        <v-text-field
          class="fix-google-chrome"
          :value="hardware.hardware_model_title"
          label="ชื่อรุ่น Device"
          disabled
        ></v-text-field>
        <v-text-field
          class="fix-google-chrome"
          :value="hardware.hardware_status_title"
          label="สถานะ Device"
          disabled
        ></v-text-field>
        <div
          v-if="
            hardware.hardware_model &&
            (hardware.hardware_model.hardware_model_code === 'vf1000' ||
              hardware.hardware_model.hardware_model_code === 'vf1000r' ||
              hardware.hardware_model.hardware_model_code === 'acu01r' ||
              hardware.hardware_model.hardware_model_code === 'vf600')
          "
        >
          <v-chip class="my-4">ตั้งค่า Network เพื่อติดต่อ Device</v-chip>
          <v-text-field
            v-model="hardware.network.ip_v4"
            class="fix-google-chrome"
            label="IPv4"
            :rules="[
              (v) =>
                !v ||
                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                  v
                ) ||
                'ระบุ IPv4 ไม่ถูกต้อง',
            ]"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="hardware.network.ip_v4_subnet"
            class="fix-google-chrome"
            label="Subnet Mask"
            :rules="[
              (v) =>
                !v ||
                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                  v
                ) ||
                'ระบุ Subnet Mask ไม่ถูกต้อง',
            ]"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="hardware.network.ip_v4_gateway"
            class="fix-google-chrome"
            label="Default Gateway"
            :rules="[
              (v) =>
                !v ||
                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                  v
                ) ||
                'ระบุ Default Gateway ไม่ถูกต้อง',
            ]"
            clearable
          ></v-text-field>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn tabindex="4" class="primary mr-3" depressed @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
          <div class="d-sr-only">{{ isHardwareDataChange }}</div>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    hardware: {
      type: Object,
    },
    hardwareInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    isHardwareDataChange() {
      if (
        this.hardware.hardware_code !== this.hardwareInit.hardware_code ||
        this.hardware.title_th !== this.hardwareInit.title_th ||
        this.hardware.title_en !== this.hardwareInit.title_en ||
        (this.hardware.network &&
          this.hardware.network.ip_v4 !== this.hardwareInit.network.ip_v4) ||
        (this.hardware.network &&
          this.hardware.network.ip_v4_subnet !==
            this.hardwareInit.network.ip_v4_subnet) ||
        (this.hardware.network &&
          this.hardware.network.ip_v4_gateway !==
            this.hardwareInit.network.ip_v4_gateway)
      ) {
        this.$emit('isHardwareDataChange', true)
        return true
      }
      this.$emit('isHardwareDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      editHardware: 'hardware/editHardware',
      updateNetworkConfig: 'hardware/updateNetworkConfig',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.hardware[field] = value.trim()
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.$store.state.loading = true

          const hardwareUpdate = {
            ...this.hardwareInit,
            company_uuid,
            hardware_serial_number: this.hardware.hardware_serial_number,
            hardware_status_uuid:
              this.hardware.hardware_status.hardware_status_uuid,
            hardware_uuid: this.hardware.hardware_uuid,
            hardware_code: this.hardware.hardware_code,
            title_th: this.hardware.title_th,
            title_en: this.hardware.title_en,
            hardware_model_code:
              this.hardware.hardware_model.hardware_model_code,
          }

          await this.editHardware(hardwareUpdate)

          if (
            this.hardware.hardware_model &&
            (this.hardware.hardware_model.hardware_model_code === 'vf1000' ||
              this.hardware.hardware_model.hardware_model_code === 'vf1000r' ||
              this.hardware.hardware_model.hardware_model_code === 'acu01r' ||
              this.hardware.hardware_model.hardware_model_code === 'vf600')
          ) {
            const payload = {
              company_uuid,
              hardware_model: this.hardware.hardware_model.hardware_model_code,
              body: {
                hardware_uuid: this.hardware.hardware_uuid,
                network: {
                  ip_v4: this.hardware.network.ip_v4 || null,
                  ip_v4_subnet: this.hardware.network.ip_v4_subnet || null,
                  ip_v4_gateway: this.hardware.network.ip_v4_gateway || null,
                },
              },
            }

            await this.updateNetworkConfig(payload)
          }
          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onClose() {
      if (this.isHardwareDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
